/**
 * Beeltra Reviews -- write-a-review token landing page (Phase R2).
 *
 * Security notes (section 6):
 * - The raw token is read from the URL ONCE, then immediately stripped
 *   from the visible URL via history.replaceState() -- never left in
 *   the address bar, browser history entry, or re-derivable from a
 *   bookmark/share of this page after that point.
 * - The token is kept only in memory (a closure variable) for the
 *   remainder of the page session -- never written to
 *   localStorage/sessionStorage/cookies, never logged to console,
 *   never included in any analytics/error-telemetry call this file
 *   makes (this file makes none).
 * - Generic "invalid or expired" messaging only -- this file never
 *   inspects/displays WHY validation failed.
 */
(function () {
  "use strict";

  var API_BASE = "https://beeltra-supplier-api.deliverypro.workers.dev";

  function setState(root, state) {
    root.querySelectorAll("[data-state]").forEach(function (el) {
      el.hidden = el.getAttribute("data-state") !== state;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-beeltra-write-review]");
    if (!root) return;

    var url = new URL(window.location.href);
    var token = url.searchParams.get("token");

    if (!token) {
      setState(root, "invalid");
      return;
    }

    // Strip the token from the visible URL immediately -- the raw value
    // stays only in this closure for the rest of the page's lifetime.
    url.searchParams.delete("token");
    window.history.replaceState({}, document.title, url.pathname + (url.search ? url.search : ""));

    fetch(API_BASE + "/api/reviews/validate-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: token }),
    })
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error("invalid"));
      })
      .then(function (data) {
        if (!data || !data.success) throw new Error("invalid");

        var imageEl = root.querySelector("[data-product-image]");
        var titleEl = root.querySelector("[data-product-title]");
        if (data.productImage) {
          imageEl.src = data.productImage;
          imageEl.hidden = false;
        }
        titleEl.textContent = data.productTitle || "";

        setState(root, "form");

        var form = root.querySelector("[data-review-form]");
        var errorEl = root.querySelector("[data-form-error]");

        form.addEventListener("submit", function (event) {
          event.preventDefault();
          errorEl.hidden = true;
          var submitBtn = form.querySelector('button[type="submit"]');
          submitBtn.disabled = true;

          var formData = new FormData(form);
          var rating = Number(formData.get("rating"));
          var payload = {
            token: token,
            rating: rating,
            title: formData.get("title") || undefined,
            body: formData.get("body"),
            reviewerDisplayName: formData.get("reviewerDisplayName") || undefined,
          };

          fetch(API_BASE + "/api/reviews/submit", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          })
            .then(function (res) {
              return res.json().then(function (body) {
                return { ok: res.ok, body: body };
              });
            })
            .then(function (result) {
              if (!result.ok || !result.body.success) {
                throw new Error(result.body && result.body.code ? result.body.code : "submit_failed");
              }
              var reviewId = result.body.reviewId;
              var imageFiles = formData.getAll("images").filter(function (f) {
                return f && f.size > 0;
              });
              if (imageFiles.length === 0) {
                setState(root, "success");
                return;
              }
              var uploads = imageFiles.slice(0, 5).map(function (file) {
                var imgForm = new FormData();
                imgForm.append("token", token);
                imgForm.append("image", file);
                return fetch(API_BASE + "/api/reviews/" + reviewId + "/images", { method: "POST", body: imgForm }).catch(function () {
                  // A failed image upload never blocks the already-
                  // successful review submission -- the review stands
                  // regardless of photo upload outcome.
                });
              });
              Promise.all(uploads).then(function () {
                setState(root, "success");
              });
            })
            .catch(function () {
              errorEl.textContent = "We couldn't submit your review. Please try again.";
              errorEl.hidden = false;
              submitBtn.disabled = false;
            });
        });
      })
      .catch(function () {
        setState(root, "invalid");
      });
  });
})();
